import { environment } from "src/environments/environment";

export const passwordPattern =
  "^(?=.*)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])[^ ]{8,32}$";
export const vatIdPattern = "^[a-zA-Z0-9]{5,15}$";
export const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const DATA_MANAGEMENT_USER_EMAILS = new Set([
  "tamarp@way2vat.com",
  "vaniab@way2vat.com",
  "mayaw@way2vat.com",
  "elirand@way2vat.com",
  "roya@way2vat.com",
  "savovicmarko986@gmail.com",
  "idanh@way2vat.com",
  "bogdan.ksonov@way2vat.com",
  "mayaw+marko@way2vat.com",
  "markos@way2vat.com",
  "tamarp+claude@way2vat.com",
  "vladimirp@way2vat.com",
]);

interface DataManagementIdentity {
  email?: string | null;
  role?: string | null;
}

export function canManageDataManagement(
  identity: DataManagementIdentity | null | undefined,
): boolean {
  const email = identity?.email?.trim().toLowerCase();
  const role = identity?.role?.toString().toLowerCase();

  return (
    role === "admin" &&
    !!email &&
    DATA_MANAGEMENT_USER_EMAILS.has(email)
  );
}

const FEES_CONFIGURATION_USER_EMAILS = new Set(
  environment.feesConfigurationUserEmails.map((email) => email.trim().toLowerCase()),
);

interface FeesConfigurationIdentity {
  email?: string | null;
  role?: string | null;
}

export function canManageFeesConfiguration(
  identity: FeesConfigurationIdentity | null | undefined,
): boolean {
  const email = identity?.email?.trim().toLowerCase();
  const role = identity?.role?.toString().toLowerCase();

  return (
    role === "admin" &&
    !!email &&
    FEES_CONFIGURATION_USER_EMAILS.has(email)
  );
}
